<!-- 资源构建 -->
<template>
  <div>
    <a-form>

    </a-form>
  </div>
</template>

<script>
export default {
  name: 'ResourceBuild',
  components: {},
  props: {},
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
  created () { },
  mounted () { }
}
</script>

<style>
</style>
